import React from 'react';
import { Outlet } from 'react-router-dom';
import { AccountAreaGuard } from '../../components/guards/AccountAreaGuard';
import { AgencyHeader } from '../../components/header/header-agency';

export const MainAgency: React.FC = () => {
  return (
    <div>
      {/* <AgencyHeader /> */}
      <AccountAreaGuard area="agency">
        <Outlet />
      </AccountAreaGuard>
    </div>
  );
};
